module.exports = __webpack_public_path__ + "files/d39b34e51715acef1f2dabdbeab81ae4.png";